export default __webpack_public_path__ + "static/media/3.f94341d5.jpg";